import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import MainPage from './MainPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import AntiDDoS from './components/antiddos';
import { ParallaxProvider } from 'react-scroll-parallax';
import Aboutus from './components/Aboutus';
import ISP from './components/ISP';
import CybersecurityTimeline from './components/CybersecurityTimeline';
import NotFound from './components/NotFound';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <ParallaxProvider>
          <Router>
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/anti-ddos" element={<AntiDDoS />} />
            <Route path="/about-us" element={<Aboutus />} />
            <Route path="/isp" element={<ISP />} />
            <Route path="/cybersecurity-timeline" element={<CybersecurityTimeline />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          </Router>
        </ParallaxProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
